import { render, staticRenderFns } from "./PublicAuthPage.vue?vue&type=template&id=057d3598&scoped=true&"
import script from "./PublicAuthPage.vue?vue&type=script&lang=ts&"
export * from "./PublicAuthPage.vue?vue&type=script&lang=ts&"
import style0 from "./PublicAuthPage.vue?vue&type=style&index=0&id=057d3598&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "057d3598",
  null
  
)

export default component.exports